var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.report.view",
  title: "Application Artisan Report View",
  description: "Primary visual shell for the Application Artisan Report dashboard.",
  styling: {
    styles: [
      {
        selector: ".app-artisan-shell",
        styles: [
          "background: radial-gradient(circle at top left, rgba($primary, 0.18), transparent 24rem), radial-gradient(circle at top right, rgba($info, 0.16), transparent 24rem), radial-gradient(circle at bottom center, rgba($warning, 0.12), transparent 26rem), linear-gradient(180deg, rgba($background-color, 0.97) 0%, rgba($background-color, 0.92) 100%);",
          "border-radius: 2rem;",
          "color: $text-color;",
          "display: flex;",
          "flex-direction: column;",
          "gap: 1.5rem;",
          "overflow: hidden;",
          "padding: 1.5rem;",
          "position: relative;"
        ]
      },
      {
        selector: ".app-artisan-shell::before",
        styles: [
          "background: linear-gradient(115deg, rgba($primary, 0.08), rgba($info, 0.08), rgba($warning, 0.08));",
          "content: '';",
          "inset: -15%;",
          "position: absolute;",
          "transform: rotate(5deg);"
        ]
      },
      {
        selector: ".app-artisan-shell > *",
        styles: [
          "position: relative;",
          "z-index: 1;"
        ]
      },
      {
        selector: ".app-artisan-hero",
        styles: [
          "align-items: center;",
          "backdrop-filter: blur(1.3rem);",
          "background: rgba($background-color, 0.82);",
          "border: 0.0625rem solid rgba($secondary, 0.22);",
          "border-radius: 1.75rem;",
          "box-shadow: 0 1.5rem 3rem rgba($background-color, 0.22);",
          "display: grid;",
          "gap: 1.5rem;",
          "grid-template-columns: minmax(0, 1.75fr) minmax(19rem, 1fr);",
          "padding: 2rem;"
        ]
      },
      {
        selector: ".app-artisan-shell[data-generating='true'] .app-artisan-hero",
        styles: [
          "border-color: rgba($primary, 0.4);"
        ]
      },
      {
        selector: ".app-artisan-eyebrow",
        styles: [
          "color: $primary;",
          "display: inline-block;",
          "font-size: 0.82rem;",
          "font-weight: 700;",
          "letter-spacing: 0.18rem;",
          "margin-bottom: 0.8rem;",
          "text-transform: uppercase;"
        ]
      },
      {
        selector: ".app-artisan-title",
        styles: [
          "font-size: clamp(2rem, 4vw, 3.8rem);",
          "letter-spacing: -0.04em;",
          "line-height: 0.98;",
          "margin: 0;"
        ]
      },
      {
        selector: ".app-artisan-subtitle,.app-artisan-status,.app-artisan-definition-meta,.app-artisan-split-meta,.app-artisan-leader-meta,.app-artisan-reward-meta,.app-artisan-empty,.app-artisan-meter-meta,.app-artisan-meter-title,.app-artisan-count-label",
        styles: [
          "color: rgba($text-color, 0.68);",
          "line-height: 1.6;"
        ]
      },
      {
        selector: ".app-artisan-status",
        styles: [
          "align-items: center;",
          "display: inline-flex;",
          "flex-wrap: wrap;",
          "font-size: 1rem;",
          "gap: 0.45rem;"
        ]
      },
      {
        selector: ".app-artisan-status[data-busy='true']::before",
        styles: [
          "background: $primary;",
          "border-radius: 999rem;",
          "content: '';",
          "display: inline-block;",
          "height: 0.7rem;",
          "width: 0.7rem;"
        ]
      },
      {
        selector: ".app-artisan-hero-meta,.app-artisan-hero-actions",
        styles: [
          "display: flex;",
          "flex-wrap: wrap;",
          "gap: 0.75rem;"
        ]
      },
      {
        selector: ".app-artisan-hero-actions",
        styles: [
          "align-items: flex-start;",
          "flex-direction: column;",
          "justify-content: center;",
          "min-width: 0;"
        ]
      },
      {
        selector: ".app-artisan-action-card",
        styles: [
          "background: rgba($text-color, 0.04);",
          "border: 0.0625rem solid rgba($secondary, 0.18);",
          "border-radius: 1.25rem;",
          "display: flex;",
          "flex-direction: column;",
          "gap: 0.85rem;",
          "padding: 1rem;",
          "width: 100%;"
        ]
      },
      {
        selector: ".app-artisan-action-copy",
        styles: [
          "color: rgba($text-color, 0.68);",
          "font-size: 0.96rem;",
          "line-height: 1.55;",
          "margin: 0;"
        ]
      },
      {
        selector: ".app-artisan-action-button",
        styles: [
          "align-items: center;",
          "display: inline-flex;",
          "font-weight: 700;",
          "gap: 0.55rem;",
          "justify-content: center;",
          "min-height: 2.85rem;",
          "white-space: normal;",
          "width: 100%;"
        ]
      },
      {
        selector: ".app-artisan-pill",
        styles: [
          "align-items: center;",
          "border-radius: 999rem;",
          "display: inline-flex;",
          "font-size: 0.78rem;",
          "font-weight: 700;",
          "gap: 0.35rem;",
          "letter-spacing: 0.05rem;",
          "padding: 0.48rem 0.82rem;",
          "text-transform: uppercase;"
        ]
      },
      {
        selector: ".app-artisan-pill-cool",
        styles: [
          "background: rgba($primary, 0.14);",
          "border: 0.0625rem solid rgba($primary, 0.34);",
          "color: $text-color;"
        ]
      },
      {
        selector: ".app-artisan-pill-warm",
        styles: [
          "background: rgba($warning, 0.14);",
          "border: 0.0625rem solid rgba($warning, 0.32);",
          "color: $text-color;"
        ]
      },
      {
        selector: ".app-artisan-generate-button",
        styles: [
          "box-shadow: 0 0.9rem 2rem rgba($primary, 0.18);"
        ]
      },
      {
        selector: ".app-artisan-shell[data-generating='true'] .app-artisan-generate-button",
        styles: [
          "box-shadow: 0 0 0 0.2rem rgba($primary, 0.12), 0 1.1rem 2.6rem rgba($primary, 0.26);"
        ]
      },
      {
        selector: ".app-artisan-metric-grid,.app-artisan-panel-grid,.app-artisan-split-grid,.app-artisan-definition-grid",
        styles: [
          "display: grid;",
          "gap: 1rem;",
          "min-width: 0;"
        ]
      },
      {
        selector: ".app-artisan-metric-grid",
        styles: [
          "align-items: stretch;",
          "grid-auto-flow: dense;",
          "grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);",
          "grid-template-rows: repeat(3, minmax(0, 1fr));"
        ]
      },
      {
        selector: ".app-artisan-metric-grid > :first-child",
        styles: [
          "grid-row: 1 / span 3;"
        ]
      },
      {
        selector: ".app-artisan-panel-grid",
        styles: [
          "grid-template-columns: repeat(2, minmax(0, 1fr));"
        ]
      },
      {
        selector: ".app-artisan-mosaic",
        styles: [
          "column-count: 2;",
          "column-gap: 1rem;"
        ]
      },
      {
        selector: ".app-artisan-mosaic > *",
        styles: [
          "break-inside: avoid;",
          "display: block;",
          "margin: 0 0 1rem;",
          "width: 100%;"
        ]
      },
      {
        selector: ".app-artisan-panel-achievements .app-artisan-rewards",
        styles: [
          "display: grid;",
          "gap: 1rem;",
          "grid-template-columns: repeat(4, minmax(0, 1fr));"
        ]
      },
      {
        selector: ".app-artisan-split-grid",
        styles: [
          "grid-template-columns: repeat(3, minmax(0, 1fr));"
        ]
      },
      {
        selector: ".app-artisan-definition-grid",
        styles: [
          "grid-template-columns: repeat(3, minmax(0, 1fr));"
        ]
      },
      {
        selector: ".app-artisan-definition-rail",
        styles: [
          "display: flex;",
          "flex-direction: column;",
          "gap: 0.8rem;"
        ]
      },
      {
        selector: ".app-artisan-trend",
        styles: [
          "background: rgba($text-color, 0.04);",
          "border-radius: 999rem;",
          "display: flex;",
          "gap: 0;",
          "height: 0.9rem;",
          "min-height: 0.9rem;",
          "overflow: hidden;",
          "padding: 0;"
        ]
      },
      {
        selector: ".app-artisan-trend-bar,.app-artisan-meter-fill",
        styles: [
          "border-radius: 0;",
          "display: block;",
          "flex: 0 0 auto;",
          "height: 100%;",
          "min-width: 0;",
          "transform: scaleX(0);",
          "transform-origin: left center;",
          "transition: transform 1.15s cubic-bezier(0.22, 1, 0.36, 1);"
        ]
      },
      {
        selector: ".app-artisan-trend.observer-visible .app-artisan-trend-bar,.app-artisan-meter-row.observer-visible .app-artisan-meter-fill",
        styles: [
          "transform: scaleX(1);"
        ]
      },
      {
        selector: ".app-artisan-trend.is-visible .app-artisan-trend-bar",
        styles: [
          "transform: scaleX(1);"
        ]
      },
      {
        selector: ".app-artisan-trend.observer-invisible .app-artisan-trend-bar,.app-artisan-meter-row.observer-invisible .app-artisan-meter-fill",
        styles: [
          "transform: scaleX(0);"
        ]
      },
      {
        selector: ".app-artisan-trend-bar-app,.app-artisan-meter-fill-app",
        styles: [
          "background: linear-gradient(90deg, $primary, rgba($primary, 0.68));"
        ]
      },
      {
        selector: ".app-artisan-trend-bar-platform,.app-artisan-meter-fill-platform",
        styles: [
          "background: linear-gradient(90deg, $info, rgba($info, 0.68));"
        ]
      },
      {
        selector: ".app-artisan-trend-bar-plugins,.app-artisan-meter-fill-plugins",
        styles: [
          "background: linear-gradient(90deg, $warning, rgba($warning, 0.68));"
        ]
      },
      {
        selector: ".app-artisan-split-card,.app-artisan-count-chip,.app-artisan-reward,.app-artisan-leader-row,.app-artisan-meter-row,.app-artisan-definition-card",
        styles: [
          "background: rgba($text-color, 0.035);",
          "border: 0.0625rem solid rgba($text-color, 0.06);",
          "border-radius: 1.2rem;",
          "padding: 0.95rem 1rem;",
          "transition: transform 0.4s ease, border-color 0.4s ease, background 0.4s ease, opacity 0.8s ease;",
          "opacity: 0;",
          "transform: translateY(1rem);"
        ]
      },
      {
        selector: ".app-artisan-count-chip,.app-artisan-definition-card",
        styles: [
          "align-items: center;",
          "display: grid;",
          "gap: 0.9rem 1rem;",
          "grid-template-columns: minmax(0, 1fr) auto;",
          "min-width: 0;"
        ]
      },
      {
        selector: ".app-artisan-split-card.is-visible,.app-artisan-count-chip.is-visible,.app-artisan-reward.is-visible,.app-artisan-leader-row.is-visible,.app-artisan-meter-row.is-visible,.app-artisan-definition-card.is-visible",
        styles: [
          "opacity: 1;",
          "transform: translateY(0);"
        ]
      },
      {
        selector: ".app-artisan-split-card:hover,.app-artisan-count-chip:hover,.app-artisan-reward:hover,.app-artisan-leader-row:hover,.app-artisan-definition-card:hover",
        styles: [
          "background: rgba($text-color, 0.055);",
          "border-color: rgba($secondary, 0.22);",
          "transform: translateY(-0.14rem);"
        ]
      },
      {
        selector: ".app-artisan-split-title,.app-artisan-reward-badge",
        styles: [
          "color: rgba($text-color, 0.62);",
          "font-size: 0.82rem;",
          "font-weight: 700;",
          "letter-spacing: 0.08rem;",
          "text-transform: uppercase;"
        ]
      },
      {
        selector: ".app-artisan-split-card-app",
        styles: [
          "border-top: 0.25rem solid rgba($primary, 0.9);"
        ]
      },
      {
        selector: ".app-artisan-split-card-platform",
        styles: [
          "border-top: 0.25rem solid rgba($info, 0.9);"
        ]
      },
      {
        selector: ".app-artisan-split-card-plugins",
        styles: [
          "border-top: 0.25rem solid rgba($warning, 0.9);"
        ]
      },
      {
        selector: ".app-artisan-split-value,.app-artisan-count-value,.app-artisan-leader-value,.app-artisan-definition-value,.app-artisan-meter-value",
        styles: [
          "font-weight: 800;"
        ]
      },
      {
        selector: ".app-artisan-value-display",
        styles: [
          "align-items: baseline;",
          "display: inline-flex;",
          "flex-wrap: wrap;",
          "gap: 0.4rem;",
          "justify-content: flex-end;",
          "max-width: 100%;"
        ]
      },
      {
        selector: ".app-artisan-value-number",
        styles: [
          "max-width: 100%;",
          "overflow-wrap: anywhere;",
          "word-break: break-word;"
        ]
      },
      {
        selector: ".app-artisan-value-unit",
        styles: [
          "color: rgba($text-color, 0.58);",
          "font-size: 0.42em;",
          "font-weight: 700;",
          "letter-spacing: 0.06em;",
          "text-transform: uppercase;"
        ]
      },
      {
        selector: ".app-artisan-count-value,.app-artisan-definition-value",
        styles: [
          "font-size: clamp(1.9rem, 4vw, 3.3rem);",
          "justify-self: end;",
          "letter-spacing: -0.05em;",
          "line-height: 0.94;",
          "text-align: right;"
        ]
      },
      {
        selector: ".app-artisan-definition-head,.app-artisan-count-copy,.app-artisan-meter-head",
        styles: [
          "align-items: center;",
          "display: flex;",
          "gap: 0.65rem;"
        ]
      },
      {
        selector: ".app-artisan-definition-copy",
        styles: [
          "display: flex;",
          "flex-direction: column;",
          "gap: 0.4rem;",
          "min-width: 0;"
        ]
      },
      {
        selector: ".app-artisan-definition-card-textual",
        styles: [
          "grid-template-columns: minmax(0, 1fr);"
        ]
      },
      {
        selector: ".app-artisan-timeline-callout",
        styles: [
          "font-size: 1rem;",
          "font-weight: 700;",
          "line-height: 1.45;"
        ]
      },
      {
        selector: ".app-artisan-age-stack",
        styles: [
          "display: flex;",
          "flex-direction: column;",
          "gap: 0.2rem;",
          "text-align: right;"
        ]
      },
      {
        selector: ".app-artisan-age-major",
        styles: [
          "font-size: clamp(1.4rem, 2.8vw, 2rem);",
          "font-weight: 800;",
          "letter-spacing: -0.04em;",
          "line-height: 0.95;"
        ]
      },
      {
        selector: ".app-artisan-age-minor",
        styles: [
          "color: rgba($text-color, 0.62);",
          "font-size: 0.9rem;",
          "font-weight: 700;",
          "letter-spacing: 0.04em;",
          "text-transform: uppercase;"
        ]
      },
      {
        selector: ".app-artisan-meter-head",
        styles: [
          "justify-content: space-between;",
          "min-width: 0;"
        ]
      },
      {
        selector: ".app-artisan-meter-row",
        styles: [
          "display: flex;",
          "flex-direction: column;",
          "gap: 0.75rem;"
        ]
      },
      {
        selector: ".app-artisan-meter-value,.app-artisan-split-value,.app-artisan-leader-value",
        styles: [
          "font-size: clamp(1.1rem, 2.5vw, 2rem);",
          "line-height: 1;",
          "text-align: right;"
        ]
      },
      {
        selector: ".app-artisan-definition-icon,.app-artisan-count-icon",
        styles: [
          "align-items: center;",
          "background: rgba($primary, 0.12);",
          "border: 0.0625rem solid rgba($primary, 0.22);",
          "border-radius: 0.85rem;",
          "display: inline-flex;",
          "height: 2rem;",
          "justify-content: center;",
          "width: 2rem;"
        ]
      },
      {
        selector: ".app-artisan-definition-title,.app-artisan-leader-title,.app-artisan-reward-title",
        styles: [
          "font-size: 1rem;",
          "font-weight: 700;",
          "max-width: 100%;",
          "overflow-wrap: anywhere;",
          "word-break: normal;"
        ]
      },
      {
        selector: ".app-artisan-leader-meta,.app-artisan-definition-meta,.app-artisan-panel-copy",
        styles: [
          "display: block;",
          "max-width: 100%;",
          "overflow-wrap: anywhere;",
          "word-break: normal;"
        ]
      },
      {
        selector: ".app-artisan-leader-copy",
        styles: [
          "min-width: 0;"
        ]
      },
      {
        selector: ".app-artisan-meter-track",
        styles: [
          "background: rgba($text-color, 0.08);",
          "border-radius: 999rem;",
          "height: 0.7rem;",
          "min-height: 0.7rem;",
          "overflow: hidden;"
        ]
      },
      {
        selector: ".app-artisan-meter-list,.app-artisan-leaderboard,.app-artisan-rewards,.app-artisan-count-rail",
        styles: [
          "display: flex;",
          "flex-direction: column;",
          "gap: 0.8rem;"
        ]
      },
      {
        selector: ".app-artisan-activity-grid",
        styles: [
          "display: grid;",
          "gap: 0.75rem;",
          "grid-template-columns: repeat(4, minmax(0, 1fr));"
        ]
      },
      {
        selector: ".app-artisan-activity-cell",
        styles: [
          "background: rgba($text-color, 0.035);",
          "border: 0.0625rem solid rgba($text-color, 0.06);",
          "border-top-width: 0.25rem;",
          "border-radius: 1rem;",
          "display: flex;",
          "flex-direction: column;",
          "gap: 0.45rem;",
          "min-width: 0;",
          "padding: 0.8rem 0.9rem;"
        ]
      },
      {
        selector: ".app-artisan-activity-intensity-0",
        styles: [
          "background: rgba($text-color, 0.025);",
          "border-top-color: rgba($text-color, 0.08);"
        ]
      },
      {
        selector: ".app-artisan-activity-intensity-1",
        styles: [
          "border-top-color: rgba($primary, 0.25);"
        ]
      },
      {
        selector: ".app-artisan-activity-intensity-2",
        styles: [
          "border-top-color: rgba($primary, 0.45);"
        ]
      },
      {
        selector: ".app-artisan-activity-intensity-3",
        styles: [
          "border-top-color: rgba($primary, 0.68);"
        ]
      },
      {
        selector: ".app-artisan-activity-intensity-4",
        styles: [
          "border-top-color: $primary;"
        ]
      },
      {
        selector: ".app-artisan-activity-month",
        styles: [
          "color: rgba($text-color, 0.62);",
          "font-size: 0.78rem;",
          "font-weight: 700;",
          "letter-spacing: 0.06rem;",
          "text-transform: uppercase;"
        ]
      },
      {
        selector: ".app-artisan-activity-total .app-artisan-value-display",
        styles: [
          "justify-content: flex-start;"
        ]
      },
      {
        selector: ".app-artisan-activity-total .app-artisan-value-number",
        styles: [
          "font-size: clamp(1rem, 2vw, 1.35rem);",
          "font-weight: 800;",
          "letter-spacing: -0.03em;"
        ]
      },
      {
        selector: ".app-artisan-leader-row",
        styles: [
          "align-items: center;",
          "display: grid;",
          "gap: 0.8rem;",
          "grid-template-columns: 2.4rem minmax(0, 1fr) auto;"
        ]
      },
      {
        selector: ".app-artisan-leader-rank",
        styles: [
          "align-items: center;",
          "background: rgba($text-color, 0.08);",
          "border-radius: 999rem;",
          "display: flex;",
          "font-size: 0.95rem;",
          "font-weight: 800;",
          "height: 2.4rem;",
          "justify-content: center;",
          "width: 2.4rem;"
        ]
      },
      {
        selector: ".app-artisan-reward",
        styles: [
          "align-items: flex-start;",
          "display: grid;",
          "gap: 0.9rem;",
          "grid-template-columns: 4.5rem minmax(0, 1fr);",
          "height: 100%;"
        ]
      },
      {
        selector: ".app-artisan-reward-badge",
        styles: [
          "align-items: center;",
          "aspect-ratio: 1;",
          "background: linear-gradient(145deg, rgba($primary, 0.2), rgba($info, 0.16));",
          "border: 0.0625rem solid rgba($text-color, 0.12);",
          "border-radius: 1.25rem;",
          "color: $text-color;",
          "display: flex;",
          "justify-content: center;"
        ]
      },
      {
        device: "ipad",
        selector: ".app-artisan-hero,.app-artisan-panel-grid,.app-artisan-split-grid,.app-artisan-definition-grid",
        styles: [
          "grid-template-columns: repeat(2, minmax(0, 1fr));"
        ]
      },
      {
        device: "ipad",
        selector: ".app-artisan-activity-grid",
        styles: [
          "grid-template-columns: repeat(3, minmax(0, 1fr));"
        ]
      },
      {
        device: "ipad",
        selector: ".app-artisan-mosaic",
        styles: [
          "column-count: 2;"
        ]
      },
      {
        device: "ipad",
        selector: ".app-artisan-panel-achievements .app-artisan-rewards",
        styles: [
          "grid-template-columns: repeat(2, minmax(0, 1fr));"
        ]
      },
      {
        device: "ipad",
        selector: ".app-artisan-metric-grid",
        styles: [
          "grid-template-columns: minmax(0, 1fr);",
          "grid-template-rows: none;"
        ]
      },
      {
        device: "ipad",
        selector: ".app-artisan-metric-grid > :first-child",
        styles: [
          "grid-row: auto;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-shell",
        styles: [
          "border-radius: 1.4rem;",
          "padding: 1rem;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-hero,.app-artisan-panel-grid,.app-artisan-metric-grid,.app-artisan-split-grid,.app-artisan-definition-grid",
        styles: [
          "grid-template-columns: minmax(0, 1fr);"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-activity-grid",
        styles: [
          "grid-template-columns: minmax(0, 1fr);"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-mosaic",
        styles: [
          "column-count: 1;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-panel-achievements .app-artisan-rewards",
        styles: [
          "grid-template-columns: minmax(0, 1fr);"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-metric-grid",
        styles: [
          "grid-template-rows: none;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-metric-grid > :first-child",
        styles: [
          "grid-row: auto;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-hero",
        styles: [
          "border-radius: 1.25rem;",
          "gap: 1rem;",
          "padding: 1.1rem;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-hero-actions",
        styles: [
          "width: 100%;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-action-card",
        styles: [
          "border-radius: 1rem;",
          "padding: 0.9rem;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-title",
        styles: [
          "font-size: 2rem;",
          "line-height: 1.02;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-leader-row,.app-artisan-reward,.app-artisan-count-chip,.app-artisan-definition-card",
        styles: [
          "align-items: start;",
          "grid-template-columns: minmax(0, 1fr);"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-count-value,.app-artisan-definition-value,.app-artisan-meter-value,.app-artisan-split-value,.app-artisan-leader-value,.app-artisan-value-display",
        styles: [
          "justify-content: flex-start;",
          "justify-self: start;",
          "text-align: left;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-definition-head,.app-artisan-count-copy,.app-artisan-meter-head",
        styles: [
          "align-items: flex-start;",
          "flex-direction: column;"
        ]
      }
    ]
  },
  fields: {
    inner: {
      type: "inner",
      required: true,
      title: "Inner",
      description: "Dashboard content inside the Application Artisan shell."
    },
    generatedOn: {
      type: "string",
      title: "Generated On",
      description: "Latest generated timestamp."
    },
    pageNamespace: {
      type: "string",
      title: "Page Namespace",
      description: "Dashboard page namespace."
    },
    apiUrl: {
      type: "string",
      title: "API URL",
      description: "Computed dashboard API URL."
    },
    hasReport: {
      type: "boolean",
      title: "Has Report",
      description: "Whether the dashboard has a current report snapshot.",
      default: false
    }
  }
});

exports.render = async function renderApplicationArtisanView(options) {
  return {
    n: "div",
    id: "application-artisan-report-root",
    c: "app-artisan-shell",
    "data-page-namespace": options.pageNamespace || "platform.application.artisan.report",
    "data-api-url": options.apiUrl || "",
    "data-generating": "false",
    "data-generated-on": options.generatedOn || "",
    "data-has-report": options.hasReport ? "true" : "false",
    i: options.inner
  };
};
